module.exports = __webpack_public_path__ + "img/dropdownicon2.290b0414.svg";